<template>
  <div class="mianDiv">
    <img
      :src="
        $common._getTerminalMsg().isMobile
          ? require('./img/empty_4.png')
          : require('./img/empty_4.png')
      "
      alt=""
      :class="$common._getTerminalMsg().isMobile ? 'imgMobile' : ''"
    />
    <div :class="$common._getTerminalMsg().isMobile ? 'textMobile' : 'textPc'">
      无访问权限~
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.mianDiv {
  // height: 100%;
  // width: 100%;
  // overflow: auto;
  // background-color: #fff;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  & > .imgMobile {
    width: 300px;
  }
  & > .textMobile {
    color: #999;
    font-size: 16px;
  }
  & > .textPc {
    color: #999;
    font-size: 17px;
  }
}
</style>
